/**
 * Click bursts. Kept to latin onomatopoeia that reads the same in every
 * locale we ship: the pool used to be half Japanese (パクッ! / おいしい! /
 * ﾄﾞｵﾝ!), which made a pizzeria or a bakery look like a Japanese restaurant.
 */
export const ONO_POOL: readonly string[] = [
  'MIAM!', 'ZAP!', 'BOOM!', 'YUM!',
  'POP!', 'POW!', 'WOW!', 'TOP!',
];

/** Returns a function that picks a random word, never repeating the previous one. */
export function createPickRandom(): () => string {
  let prevIdx = -1;
  return () => {
    if (ONO_POOL.length < 2) return ONO_POOL[0];
    let idx: number;
    do {
      idx = Math.floor(Math.random() * ONO_POOL.length);
    } while (idx === prevIdx);
    prevIdx = idx;
    return ONO_POOL[idx];
  };
}
